import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export const useSlider = () => {
  const swiper = new Swiper('#reviews-slider', {
    modules: [Navigation],
    spaceBetween: 16,
    slidesPerView: 1,
    autoHeight: false,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      900: {
        slidesPerView: 3
      }
    }
  })
}
